// src/components/PricingSection.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

import './PricingSection.css';

export default function PricingSection() {
  const plans = [
    {
      name: 'Starter',
      price: 129.99,
      popular: false,
      features: [
        'Professionele one-page website',
        'Basis branding & huisstijl',
        'Basis SEO & indexatie',
        '1 social media kanaal',
        'Maandelijkse rapportage',
      ],
    },
    {
      name: 'Professional',
      price: 229.99,
      popular: true,
      features: [
        'Website tot 5 pagina’s',
        'Uitgebreide branding & logo',
        'Geavanceerde SEO-optimalisatie',
        'Online marketing campagne',
        'Maandelijkse rapportage & call',
      ],
    },
    {
      name: 'Premium',
      price: 399.99,
      popular: false,
      features: [
        'Maatwerk website (onbeperkt pagina’s)',
        'Full branding & design',
        'Premium SEO + linkbuilding',
        'Uitgebreide marketing campagne',
        'Wekelijkse rapportage & strategie-call',
      ],
    },
  ];

  const solidPlans = ['Professional'];

  return (
    <section id="pricing" className="pricing-section py-5">
      <div className="container">
        <header className="text-center mb-5">
          <h2 className="pricing-title">Alles-in-één pakketten voor online groei</h2>
          <p className="pricing-subtitle">
            Websites, branding, SEO en social media in één service.
          </p>
        </header>

        <div className="row gy-4 gx-lg-4 justify-content-center align-items-stretch">
          {plans.map((plan, idx) => (
            <div key={idx} className="col-12 col-md-6 col-lg-4">
              <article className={`price-card shadow-sm ${plan.popular ? 'price-card--popular' : ''}`}>
                {plan.popular && <span className="badge-popular">Populair</span>}

                <div>
                  <h3 className="plan-name mb-3">{plan.name}</h3>
                  <div className="price-wrapper mb-2">
                    <span className="currency">€</span>
                    <span className="amount">{plan.price}</span>
                  </div>
                  <p className="price-period mb-4">per maand (excl. btw)</p>

                  <ul className="feature-list mb-4 flex-grow">
                    {plan.features.map((label, i) => (
                      <li key={i} className="feature-item included">
                        <FontAwesomeIcon icon={faCheckCircle} className="me-2 feature-icon" />
                        {label}
                      </li>
                    ))}
                  </ul>
                </div>

                <a
                  href="/contact"
                  className={`btn btn-lg w-100 mt-auto ${solidPlans.includes(plan.name) ? 'btn-orange' : 'btn-outline-orange'}`}
                  role="button"
                  aria-label={`Neem contact op over ${plan.name}`}
                >
                  Kies {plan.name}
                </a>
              </article>
            </div>
          ))}
        </div>

        <p className="text-center mt-4 small">
          * Alle prijzen zijn excl. btw. Geen opstartkosten of verborgen kosten.
        </p>
      </div>
    </section>
  );
}
